import { render, staticRenderFns } from "./SubDrawerDone.vue?vue&type=template&id=5cade060&scoped=true"
import script from "./SubDrawerDone.vue?vue&type=script&lang=ts"
export * from "./SubDrawerDone.vue?vue&type=script&lang=ts"
import style0 from "./SubDrawerDone.vue?vue&type=style&index=0&id=5cade060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cade060",
  null
  
)

export default component.exports